<template>
  <div class="ErrorList">
    <el-dialog
        :title="row.roleId ? $t('laund.laund9') : $t('add')"
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
        width="460px"
        center
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-suffix=":"
          label-width="auto"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('cnumber.cnumber3')" prop="role">
            <el-input size="small" v-model="ruleForm.role" :placeholder="$t('common.pleaseInput')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cnumber.cnumber4')" prop="roleName">
            <el-input size="small" v-model="ruleForm.roleName" :placeholder="$t('common.pleaseInput')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cnumber.cnumber5')" prop="dataPermissions">
            <el-select size="small" v-model="ruleForm.dataPermissions">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('cnumber.cnumber25')" prop="roleStatus">
            <el-switch
                v-model="ruleForm.roleStatus"
                :active-text="$t('cnumber.cnumber6')"
                :inactive-text="$t('cnumber.cnumber7')"
                active-value="1"
                inactive-value="0"
                :disabled="row.bindCount > 0"
            >
            </el-switch>
          </el-form-item>
          <el-form-item :label="$t('cnumber.cnumber16')" prop="menu">
            <el-scrollbar height="200px" style="margin-top: 7px;">
            <el-tree
                :data="data"
                show-checkbox
                ref="tree"
                node-key="id"
                @check-change="handleTreeChange"
                :props="defaultProps"
                style="margin-left: -20px;"
            >
            </el-tree>
            </el-scrollbar>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
        <el-button class="form-btn btn-blue" @click="submitForm('ruleForm')">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "RoleItem",
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      ruleForm: {
        role: undefined,
        roleName: undefined,
        dataPermissions: undefined,
        menu: undefined,
        roleStatus: '1',
      },
      options: [{
        value: '0',
        label: this.$t('cnumber.cnumber31')
      }, {
        value: '1',
        label: this.$t('cnumber.cnumber24')
      }],
      rules: {
        role: [{ required: true, message: this.$t('common.pleaseInput') + this.$t('cnumber.cnumber3'), trigger: 'blur' }],
        roleName: [{ required: true, message: this.$t('common.pleaseInput') + this.$t('cnumber.cnumber4'), trigger: 'blur' }],
        dataPermissions: [{ required: true, message: this.$t('common.pleaseSelect') + this.$t('cnumber.cnumber5'), trigger: 'blur' }],
        menu: [{ required: true, message: this.$t('common.pleaseSelect') + this.$t('cnumber.cnumber16'), trigger: 'blur' }],
      },
      data: [
        {
          id: 14,
          path: "cart",
          name: "Cart",
          label: this.$t('router.router15'),
        },
        {
          id: 3,
          path: "orderList",
          name: "orderList",
          label: this.$t('store.store1'),
        },
        // {
        //   id: 21,
        //   path: "bundle",
        //   name: "bundle",
        //   label: this.$t('cnumber.cnumber21'),
        // },
        {
          id: 6,
          path: "FBA",
          name: "FBA",
          label: this.$t('cnumber.cnumber22'),
        },
        // {
        //   id: 8,
        //   path: "inStorageOrder",
        //   name: "inStorageOrder",
        //   label: this.$t('inStorageOrder.inStorageOrder1'),
        //   count: 0,
        // },
        {
          id: 7,
          path: "badOrder",
          name: "badOrder",
          label: this.$t('orderList.orderList12'),
          count: 0,
        },
        {
          id: 9,
          path: "funding",
          name: "funding",
          label: this.$t('router.router5'),
        },
        {
          id: 2,
          path: "recharge",
          name: "recharge",
          label: this.$t('store.store3'),
        },
        {
          id: 11,
          path: "message",
          name: "message",
          label: this.$t('store.store5'),
        },
        {
          id: 12,
          path: "address",
          name: "Address",
          label: this.$t('addr.addr1'),
        },
        {
          id: 13,
          path: "defective",
          name: "defective",
          label: this.$t('defe.defe1'),
        },
        {
          id: 15,
          path: "laundryLabelTemplate",
          name: "laundryLabelTemplate",
          label: this.$t('store.store6'),
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  mounted() {
    // console.log(this.row,789);
    if (this.row.roleId) {
      this.ruleForm = {...this.row}
      this.ruleForm.menu = JSON.parse(this.ruleForm.menu)
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.ruleForm.menu);
      })
      if(this.row.bindCount > 0){
        this.ruleForm.roleStatus = '1'
      }
    }
  },
  methods: {
    submitForm(formName) {
      // 菜单 menu
      const params = {
        ...this.ruleForm,
        menu: JSON.stringify(this.ruleForm.menu),
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.row.roleId) {
            // 编辑
            this.$http.post("admin/clientRoleUpdate", params).then(res => {
              // console.log(res,11223344)
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
                // 父组件更新使用
                this.$options.confirm(true)
              }else {
                this.$message({
                  type: "warning",
                  message: res.data.message,
                });
              }
            });
          }else {
            // 新增
            this.$http.post("admin/clientRoleAdd", params).then(res => {
              // console.log(res,112233)
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
                // 父组件更新使用
                this.$options.confirm(true)
              }else {
                this.$message({
                  type: "warning",
                  message: res.data.message,
                });
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    },
    handleTreeChange() {
      // 获取所有选中的节点 id
      const checkedKeys = this.$refs.tree.getCheckedKeys()

      // 同步到 form
      this.ruleForm.menu = checkedKeys

      // 手动触发表单校验
      this.$refs['ruleForm'].validateField('menu')
    },
  }
}
</script>

<style scoped lang="less">
.ErrorList{
  :deep(.el-dialog__body){
    padding: 0 20px;
  }
  :deep(.el-dialog__footer){
    padding: 0 20px 20px;
  }
  .el-input-number {
    width: 100%;
    :deep(.el-input__inner){
      text-align: left;
    }
  }
}

</style>
